import React from "react";

function BackIcon({css}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="22"
      viewBox="0 0 12 22"
      fill="none"
      className={`header-transition ${css}`}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16211 21.5398C9.73068 22.1534 10.6525 22.1534 11.221 21.5398C11.7896 20.9261 11.7896 19.9311 11.221 19.3174L3.51521 11L11.221 2.68261C11.7896 2.06892 11.7896 1.07394 11.221 0.460262C10.6525 -0.153421 9.73068 -0.153421 9.16211 0.460262L0.426815 9.88885C-0.141736 10.5025 -0.141736 11.4975 0.426815 12.1112L9.16211 21.5398Z"
        fill="#000"
        className="fill-current"
      />
    </svg>
  );
}

export default BackIcon;
